import { jsx as _jsx } from "react/jsx-runtime";
import { Label as LabelPrimitive } from "radix-ui";
import { cn } from "../lib/cn.js";
export function Label({ className, ...props }) {
    return _jsx(LabelPrimitive.Root, { className: cn("text-sm leading-none font-medium", className), ...props });
}
//# sourceMappingURL=label.js.map